import { WEBSHOP_BASE_URL } from 'constants/index'
import { useEffect, useState } from 'react'

export const useShippingMethods = container => {
  const [shippingMethods, setShippingMethods] = useState([])
  const [loading, setLoading] = useState(true)
  const [country, setCountry] = useState('FI')

  useEffect(() => {
    const url = `${WEBSHOP_BASE_URL.replace(
      /\/$/,
      ''
    )}/wp-json/holmasto/v1/class-shipping-methods?country=${country}&shipping_class=${container}`
    setLoading(true)
    fetch(url)
      .then(async response => {
        if (response.status === 404) {
          throw new Error('route not found')
        }
        return response.json()
      })
      .then(data => {
        setShippingMethods(Object.keys(data).map(method => ({ method, price: data[method] })))
        setLoading(false)
      })
      .catch(error => {
        console.error(error)
        setLoading(false)
      })
  }, [country, container])

  return [shippingMethods, loading, setCountry]
}
